
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $908a500901dcb8f1$exports = {};
$908a500901dcb8f1$exports = JSON.parse("[{\"day\":\"mon\",\"amount\":17.45},{\"day\":\"tue\",\"amount\":34.91},{\"day\":\"wed\",\"amount\":52.36},{\"day\":\"thu\",\"amount\":31.07},{\"day\":\"fri\",\"amount\":23.39},{\"day\":\"sat\",\"amount\":43.28},{\"day\":\"sun\",\"amount\":25.48}]");


const $1505a6c9338899f4$var$btnReload = /**@type {HTMLButtonElement} */ document.querySelector('button[class="btn-refresh"]');
const $1505a6c9338899f4$var$failure = /**@type {HTMLDivElement} */ document.querySelector('div[class~="failure"]');
const $1505a6c9338899f4$var$success = /**@type {HTMLDivElement} */ document.querySelector('div[class~="success"]');
const $1505a6c9338899f4$var$balance = /**@type {HTMLParagraphElement}*/ document.querySelector('.expense-chart-component__balance');
const $1505a6c9338899f4$var$amountPerDay = /**@type {NodeListOf<HTMLTableElement>} */ document.querySelectorAll('tr td');
const $1505a6c9338899f4$var$daysOfWeek = /**@type {NodeListOf<HTMLTableElement>}*/ document.querySelectorAll('tr span[aria-hidden="true"]');
const $1505a6c9338899f4$var$tableRows = /**@type {NodeListOf<HTMLTableRowElement>} */ document.querySelectorAll('tbody tr');
const $1505a6c9338899f4$var$DELAY = /**@type{number} */ 1000;
const $1505a6c9338899f4$var$SUNDAY = 0;
const $1505a6c9338899f4$var$MONDAY = 1;
const $1505a6c9338899f4$var$TUESDAY = 2;
const $1505a6c9338899f4$var$WEDNESDAY = 3;
const $1505a6c9338899f4$var$THURSDAY = 4;
const $1505a6c9338899f4$var$FRIDAY = 5;
const $1505a6c9338899f4$var$SATURDAY = 6;
const $1505a6c9338899f4$var$FIRST_NODE_INDEX = $1505a6c9338899f4$var$SUNDAY;
const $1505a6c9338899f4$var$SECOND_NODE_INDEX = $1505a6c9338899f4$var$MONDAY;
const $1505a6c9338899f4$var$THIRD_NODE_INDEX = $1505a6c9338899f4$var$TUESDAY;
const $1505a6c9338899f4$var$FOURTH_NODE_INDEX = $1505a6c9338899f4$var$WEDNESDAY;
const $1505a6c9338899f4$var$FIFTH_NODE_INDEX = $1505a6c9338899f4$var$THURSDAY;
const $1505a6c9338899f4$var$SIXTH_NODE_INDEX = $1505a6c9338899f4$var$FRIDAY;
const $1505a6c9338899f4$var$SEVENTH_NODE_INDEX = $1505a6c9338899f4$var$SATURDAY;
/**
 * A function that set the background-color of the table rows for the days of the week.
 * @param {number} index - The index of the table rows
 * @returns {void}
 */ function $1505a6c9338899f4$var$setBackgroundColor(index) {
    $1505a6c9338899f4$var$tableRows[index].addEventListener('mouseenter', function(evtObj) {
        if (evtObj.target instanceof HTMLTableRowElement) {
            const tableRow = evtObj.target;
            $1505a6c9338899f4$var$createBackgroundColor(tableRow, '--cyan-hovered', 'hsla(186, 49%, 80%, 1)');
        }
    });
    $1505a6c9338899f4$var$tableRows[index].addEventListener('mouseleave', function(evtObj) {
        if (evtObj.target instanceof HTMLTableRowElement) {
            const tableRow = evtObj.target;
            $1505a6c9338899f4$var$createBackgroundColor(tableRow, '--cyan', 'hsl(186, 34%, 60%)');
        }
    });
    $1505a6c9338899f4$var$createBackgroundColor($1505a6c9338899f4$var$tableRows[index], '--cyan', 'hsl(186, 34%, 60%)');
}
/**
 * This function creates the background color for the chart for the corresponding day
 * @param {HTMLTableRowElement} bar -- The event object
 * @param {string} cssVariable -- The CSS variable property
 * @param {string} colorCode -- The color code
 * @returns {void}
 */ function $1505a6c9338899f4$var$createBackgroundColor(bar, cssVariable, colorCode) {
    bar?.style.setProperty(cssVariable, colorCode);
    bar.style.backgroundColor = `var(${cssVariable})`;
}
/**
 * This function will increase the height of each bar chart
 */ function $1505a6c9338899f4$var$animateBarChart() {
    $1505a6c9338899f4$var$tableRows.forEach(function(tableRow, index) {
        tableRow.classList.add('day');
        $1505a6c9338899f4$var$amountPerDay[index].classList.remove('hide');
    });
}
/**
 * This function will render the days and amounts information on the UI
 */ function $1505a6c9338899f4$var$renderDaysAndAmounts() {
    try {
        if (!Array.isArray((0, (/*@__PURE__*/$parcel$interopDefault($908a500901dcb8f1$exports))))) throw new Error('Oops! You are lost');
        const dataValues = (0, (/*@__PURE__*/$parcel$interopDefault($908a500901dcb8f1$exports)));
        dataValues.forEach(function(dataValue, index) {
            $1505a6c9338899f4$var$amountPerDay[index].textContent = `$${dataValue.amount}`;
            $1505a6c9338899f4$var$daysOfWeek[index].textContent = dataValue.day;
        });
        $1505a6c9338899f4$var$failure?.classList.add('hide');
        $1505a6c9338899f4$var$success?.classList.remove('hide');
        $1505a6c9338899f4$var$balance?.classList.remove('failure');
        setTimeout($1505a6c9338899f4$var$animateBarChart, $1505a6c9338899f4$var$DELAY);
        // We need to know what the current date us nd compare with the days of the week from the chart, then we apply a different color for the corresponding individual bar chart.
        const currentDate = new Date();
        const currentDay = currentDate.getDay();
        // Using a switch case we want to evaluate the expression above and match the value of that expression to a series of case clauses.
        switch(currentDay){
            case $1505a6c9338899f4$var$SUNDAY:
                $1505a6c9338899f4$var$setBackgroundColor($1505a6c9338899f4$var$SEVENTH_NODE_INDEX);
                break;
            case $1505a6c9338899f4$var$MONDAY:
                $1505a6c9338899f4$var$setBackgroundColor($1505a6c9338899f4$var$FIRST_NODE_INDEX);
                break;
            case $1505a6c9338899f4$var$TUESDAY:
                $1505a6c9338899f4$var$setBackgroundColor($1505a6c9338899f4$var$SECOND_NODE_INDEX);
                break;
            case $1505a6c9338899f4$var$WEDNESDAY:
                $1505a6c9338899f4$var$setBackgroundColor($1505a6c9338899f4$var$THIRD_NODE_INDEX);
                break;
            case $1505a6c9338899f4$var$THURSDAY:
                $1505a6c9338899f4$var$setBackgroundColor($1505a6c9338899f4$var$FOURTH_NODE_INDEX);
                break;
            case $1505a6c9338899f4$var$FRIDAY:
                $1505a6c9338899f4$var$setBackgroundColor($1505a6c9338899f4$var$FIFTH_NODE_INDEX);
                break;
            case $1505a6c9338899f4$var$SATURDAY:
                $1505a6c9338899f4$var$setBackgroundColor($1505a6c9338899f4$var$SIXTH_NODE_INDEX);
                break;
            default:
                $1505a6c9338899f4$var$tableRows.forEach(function(tableRow) {
                    tableRow.style.setProperty('--soft-red', 'hsl(10, 79%, 65%)');
                    tableRow.style.backgroundColor = 'var(--soft-red)';
                });
        }
    } catch (error) {
        const [strongText, normalText] = error.message.split('!');
        const failureMessage = /**@type {HTMLParagraphElement} */ document.querySelector('.failure__message');
        const strongFailureMessage = /**@type {HTMLElement} */ document.querySelector('.failure__message strong');
        strongFailureMessage.textContent = `${strongText}!`;
        if (!failureMessage.innerHTML.includes(normalText.trim())) {
            const normal = document.createTextNode(normalText.trim());
            failureMessage.appendChild(normal);
        }
        $1505a6c9338899f4$var$failure?.classList.remove('hide');
        $1505a6c9338899f4$var$success?.classList.add('hide');
        $1505a6c9338899f4$var$balance?.classList.add('failure');
        $1505a6c9338899f4$var$btnReload.addEventListener('click', function() {
            $1505a6c9338899f4$var$renderDaysAndAmounts();
        });
    }
}
$1505a6c9338899f4$var$renderDaysAndAmounts();


//# sourceMappingURL=index.4d7d81d6.js.map
